export const LIVERAMP_TAG = `<script src="https://ats-wrapper.privacymanager.io/ats-modules/4fb7b1a8-b529-4310-9387-3398aed19fa4/ats.js"></script>`;
